import { Protocol } from "../../../../models/Entities/Protocols/Protocol";
import { ErrorType } from "../../../../models/HttpError";

// stores
import * as ContractStore from '../../../../redux/middleware/ContractMiddleware';
import * as MedicalProtocolStore from '../../../../redux/middleware/MedicalProtocolMiddleware';

// State
import { AppState } from "../../../../redux/reducers";
import { Contract } from "../../../../models/Entities/Contracts/Contract";
import { ContractProtocolAssociation } from "../../../../models/Entities/Contracts/ContractProtocolAssociation";

interface IProps {
    ProtocolId: number;
}

interface ConnectedProps {
    isLoading: boolean;
    Protocol: Protocol | undefined;
    ContractAssociation: ContractProtocolAssociation | undefined;
    AssociatedContract: Contract | undefined;
    error: ErrorType | undefined;
}

interface DispatchProps {
    GetAllProtocolContractAssociations: typeof MedicalProtocolStore.actionCreators.GetAllProtocolContractAssociations;
    GetContractById: typeof ContractStore.actionCreators.GetContractById;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const protocol = state.MedicalProtocols?.list?.find(
        (item: Protocol) => item.id === ownProps.ProtocolId
    );
    const contractAssociation = protocol?.contractAssociation;
    const contract = contractAssociation
        ? state.Contract?.list?.find(
              (item: Contract) => item.id === contractAssociation.contractId
          )
        : undefined;

    return {
        isLoading:
            //state.MedicalProtocols?.isLoadingAll ||
            state.MedicalProtocols?.isGettingProtocolContractAssociation, // ||
            //state.Contract?.isLoadingOne,
        Protocol: protocol,
        ContractAssociation: contractAssociation,
        AssociatedContract: contract,
        error: state.MedicalProtocols?.error,
    };
};

export const mapDispatchToProps = {
    ...ContractStore.actionCreators,
    ...MedicalProtocolStore.actionCreators,
};
